import Content from './src'
Content.install = (Vue) => {
  Vue.component(Content.name, Content)
}
export default Content



// WEBPACK FOOTER //
// ./packages/material-content/index.js